<div class="container padding-top padding-bottom">
  <md-card *ngIf="!showLoading; else loading">
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>Custom (HTML) Tags</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Select a Location</h5>
        <div class="btn-group full-width"
             dropdown>

          <button class="btn btn-default btn-lg full-width btnCheckbox dropdown-toggle"
                  dropdownToggle
                  placement="right"
                  style="box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0);margin-right: 20px;"
                  type="button">

            {{selectedLocation?.name || 'Select a Location'}}
          </button>
          <ul class="dropdown-menu dropdown-menu-right ng-star-inserted full-width"
              *dropdownMenu
              role="menu">

            <li role="menuitem"
                *ngFor="let location of locationsData; let last = last">
              <a class="dropdown-item"
                 (click)="changeLocation(location)"
                 style="cursor: pointer;">
                <h5
                    style="padding: 0;-webkit-margin-before: 0em;-webkit-margin-after: 0em;font-size: 16px; font-weight: 600;">
                  {{location.name}}</h5>
              </a>
              <hr *ngIf="!last"
                  style="margin-top: 0;margin-bottom: 0;">
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-2">
        <p>Put the FB Pixel id for each location. When the caches updates next a Catalog will be made in FB for each
          Pixel. <br><br> Once the Catalog has pulled in the units, then update the product sets! <br><br> You cannot
          create
          empty
          Product Sets. <br>
          <a href="https://www.facebook.com/products/">Catalog</a>
        </p>
        <button class="btn btn-primary float-right"
                (click)="updateProductSets()">Create FB Product Sets</button>
      </div>
    </div>

    <div *ngIf="selectedLocation"
         class="row padding-top padding-bottom">
      <div class="col-xs-12">
        <h3>XPS</h3>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="selectedLocation?.xpsInfo.active">
              Active
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Span ID</label>
            <input pInputText
                   [(ngModel)]="selectedLocation?.xpsInfo.spanId" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Span Onclick</label>
            <input pInputText
                   [(ngModel)]="selectedLocation?.xpsInfo.onclick" />
          </div>
          <div class="col-xs-12 sm-margin-top">
            <label>JS</label>
            <textarea pInputTextarea
                      [(ngModel)]="selectedLocation?.xpsInfo.js"
                      class="full-width"></textarea>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <h3>Facebook Pixel</h3>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="selectedLocation?.facebookPixelInfo.active">
              Active
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>ID</label>
            <input pInputText
                   [(ngModel)]="selectedLocation?.facebookPixelInfo.id" />
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <h3>Podium</h3>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="selectedLocation?.podiumInfo.active">
              Active
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>API Token</label>
            <input pInputText
                   [(ngModel)]="selectedLocation?.podiumInfo.apiToken" />
          </div>
        </div>
      </div>
    </div>
    <div class="row padding-top">
      <div class="col-md-12">
        <button *ngIf="selectedLocation"
                style="float: right;"
                (click)="save()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>

  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>
<div *ngIf="showSpinner">
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/integrations/integrations.component.html